import 'css-chunksrc/feature/check/CheckTotalEntry.module.scss';export default {
  "balance": "CheckTotalEntry_balance"
};